export default __webpack_public_path__ + "static/pairing-do-2ea771e422792aaffda1eeb0414cbefc.png";